import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {MainStoreKey} from './main-store.actions';
import {mainStoreReducer} from './main-store.reducer';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(MainStoreKey, mainStoreReducer),
  ]
})
export class MainStoreModule { }
